import React from 'react';
import { number, string } from 'prop-types';

const IconBuild = ({ size = 24, fill = '#30435D' }) => {
  return (
    <svg data-test="iconbuild" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0905 13.5766L5.01052 22.6566C4.61052 23.0566 3.98052 23.0566 3.60052 22.6566L1.30052 20.3566C0.910517 19.9666 0.910517 19.3366 1.30052 18.9466L10.4105 9.83659C9.54052 7.51659 10.0305 4.80659 11.8905 2.94659C14.1805 0.646592 17.7705 0.436592 20.3105 2.29659L16.4805 6.12659L17.8905 7.54659L21.7405 3.70659C23.6005 6.25659 23.3905 9.83659 21.0905 12.1366C19.1905 14.0266 16.4305 14.5066 14.0905 13.5766ZM12.8705 10.1966L3.41052 19.6566L4.30052 20.5366L13.7505 11.0866C14.3405 11.5466 15.0005 11.8466 15.7105 11.9666C17.1005 12.2166 18.5905 11.8066 19.6705 10.7266C20.6105 9.77659 21.0505 8.52659 20.9805 7.28659L17.8905 10.3766L13.6505 6.13659L16.7405 3.04659C15.5005 2.97659 14.2405 3.41659 13.3005 4.36659C12.2605 5.40659 11.8505 6.83659 12.0505 8.19659C12.1505 8.90659 12.4205 9.58659 12.8705 10.1966Z"
        fill={fill}
      />
    </svg>
  );
};

IconBuild.propTypes = {
  size: number,
  fill: string,
};

export default IconBuild;
